<template>
    <b-form-select :value="countryValue" :name="name" @change="onChange" :class="{ 'has-selection': this.value }">
        <option value="" selected disabled hidden>{{ placeholder }}</option>
        <option v-for="option in countryOptions" :value="option.value" :key="option.value">{{ option.text }}</option>
    </b-form-select>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        placeholder: {
            default: 'Country',
        },
        name: {
            default: 'country',
        },
        guess: {
            default: false,
        },
    },
    data() {
        return {
            countries: [],
            loadingCountries: false,
            countryValue: this.value,
        };
    },
    created() {
        this.getCountries();

        if (this.guess && !this.value) {
            this.guessCountry();
        }
    },
    computed: {
        countryOptions() {
            return this.countries ? this.countries : [];
        },
    },
    methods: {
        onChange(event){
            this.$emit('input', event);
        },
        getCountries() {
            const _this = this;
            axios.get('/api/geolocation/countries').then((response) => {
                _this.countries = response.data.data;
            });
        },
        guessCountry() {
            axios
                .get('/geocode/country')
                .then((response) => {
                    if (response.data != 'ZZ') {
                        this.countryValue = response.data;
                        this.$dispatch('input', response.data);
                    }
                })
                .catch(() => {
                    //
                });
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.countryValue = newVal;
            },
        },
    },
};
</script>

<style scoped>
select {
    color: #cfd0cf;
}

select.has-selection {
    color: #000;
}
</style>
